import LocalStorageAdapter from 'shared/localstorage_adapter.js';
import { UniqueId } from 'shared/vidio_helpers';
import { debounce } from 'throttle-debounce';
import { getExperiment } from "shared/vidio_helpers";
import AhoyEvent from 'shared/ahoy_event';
const Cookies = require('js-cookie');

export default class SearchSuggestion {
  constructor({ $element: $element }){
    this.$element = $($element);
    this._uuid = UniqueId.get();
    this.experiment = getExperiment();

    this.selector = {
      searchBox: 'input.js__main-search#q',
      searchReset: '.js-main-search-reset',
      eventTarget: 'body .site-header__search',
    };

    this.classNames = {
      menu: 'site-header__tt-menu',
      dataset: 'site-header__tt-dataset',
      suggestion : 'site-header__tt-suggestion',
      highlight: 'site-header__tt-highlight',
      cursor: 'site-header__tt-cursor'
    };

    this.ui = {};

    Object.keys(this.selector).forEach((key) => {
      this.ui[key] = $(this.selector[key]);
    });

    this.typeaheadInitialized = false;

    this.suggestionCache = {};
    this.isImpressionSent = {
      PopularKeyword: false,
      AutoSuggest: false
    };
    this.eventAction = 'impression::search';
    this.DOMParser = new DOMParser();

    this.popularSearchKeywords = window.popular_search_keywords;
  }

  init() {
    this.ui.searchBox.on('click', this.initializeTypeahead.bind(this));
    this.ui.searchBox.on('input', this.initializeTypeahead.bind(this));
    this.ui.searchBox.on('focus', this.showOverlay.bind(this));
    this.ui.searchBox.on('blur', this.hideOverlay.bind(this));
    this.ui.searchBox.on('keyup', this.blurSearchbar.bind(this));

    this.ui.searchReset.on('click', this.resetSearch.bind(this));

    this.ui.eventTarget.on('click', '.js-search-submit', this.selected.bind(this));
    this.ui.eventTarget.on('click', '.js-remove-search', function(e){
      this.removeSearchHistory(e);
      this.ui.searchBox.typeahead('open');
      this.ui.searchBox.typeahead('val', '');
    }.bind(this));

    this.onImpression();
    this.$element.on("submit", this.initSubmit.bind(this));
  }

  experimentEnabled() {
    return this.$element.data('searchExperimentEnabled');
  }

  variant() {
    let variant = {
      0: 'variant_a',
      1: 'variant_b'
    }

    return variant[this.experiment]
  }

  uuid() {
    return this._uuid
  }

  initSubmit(e) {
    Cookies.set("search_uuid", this.uuid());

    if (this.experimentEnabled()) {
      this.$element.append(`<input type="hidden" name="v" value="${this.variant()}"/>`);
    }

    const query = this.ui.searchBox.val().trim();

    if (query) {
      this.saveSearchHistory(query);
    } else {
      e.preventDefault();
    }
  }

  selected(e) {
    if (e.currentTarget.dataset.ahoyProps) {
      this.sendAhoyProps(e.currentTarget.dataset.ahoyProps)
    }

    this.hideOverlay();
    this.$element.submit();
  }

  sendAhoyProps(props) {
    const uuid = Cookies.get('search_uuid') || this.uuid();
    const ahoyTitle = 'VIDIO::SEARCH'
    const ahoy = JSON.parse(props)
    const ahoyPropsClick = Object.assign({}, ahoy, {search_uuid: uuid})
    const ahoyPropsSearch = Object.assign({}, ahoyPropsClick, {action: 'search'})

    AhoyEvent.send(ahoyTitle, ahoyPropsClick)
    AhoyEvent.send(ahoyTitle, ahoyPropsSearch)
  }

  showOverlay() {
    $('.site-header__search').addClass('site-header__overlay');
  }

  hideOverlay() {
    $('.site-header__search').removeClass('site-header__overlay');
  }

  blurSearchbar(event) {
    if (event.keyCode === 27) {
      this.ui.searchBox.blur();
    }
    this.toggleResetButton();
  }

  toggleResetButton() {
    if(this.ui.searchBox[0].value.length <= 0) {
      this.ui.searchReset.hide();
    } else {
      this.ui.searchReset.show();
    }
  }

  resetSearch(e) {
    e.preventDefault();
    this.ui.searchReset.hide();
    this.ui.searchBox.typeahead('val', '');
  }

  saveSearchHistory(query) {
    let searchQuery = [];

    if (LocalStorageAdapter.getItem('vidio_search_history') !== null) {
      const storedQuery = LocalStorageAdapter.getItem('vidio_search_history');
      searchQuery = JSON.parse(storedQuery);
    }

    searchQuery.unshift(query);
    const filteredQuery = [...new Set(searchQuery)].slice(0,5);

    LocalStorageAdapter.setItem('vidio_search_history', JSON.stringify(filteredQuery));
  }

  htmlEntities(str) {
    return String(str)
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  initializeTypeahead() {
    if (!this.typeaheadInitialized) {
      this.ui.searchBox.typeahead(
        {
          hint: false,
          highlight: true,
          minLength: 0,
          classNames: this.classNames
        },
        {
          name: 'keywords',
          source: this.cachedKeywords.bind(this),
          display: 'value',
          templates: {
            suggestion: this.getTemplate.bind(this),
            footer: this.getFooter.bind(this)
          }
        },
        {
          name: 'keywords',
          source: debounce(window.searchSuggestionDebounceTime || 300, this.suggestedKeywords.bind(this)),
          display: 'value',
          templates: {
            suggestion: this.getTemplate.bind(this),
            footer: this.getFooter.bind(this)
          }
        },
        {
          name: 'keywords',
          source: this.historyKeywords.bind(this),
          display: 'value',
          templates: {
            header: this.getHeader("Pencarian Terakhir"),
            suggestion: this.getRecentSearchTemplate.bind(this),
            footer: this.getFooter.bind(this)
          }
        },
        {
          name: 'keywords',
          source: this.popularKeywords.bind(this),
          display: 'value',
          templates: {
            header: this.getHeader("Pencarian Populer"),
            suggestion: this.getTemplate.bind(this),
            footer: this.getFooter.bind(this)
          }
        }
      );

      this.typeaheadInitialized = true;
      this.ui.searchBox.focus();
    }
  }

  removeSearchHistory(e)  {
    e.preventDefault();
    e.stopPropagation();
    const recentQueries = JSON.parse(LocalStorageAdapter.getItem('vidio_search_history'));
    const removedKeyword = $(e.currentTarget).attr('data-keyword');

    const newQueries = recentQueries.filter(query => query !== removedKeyword);
    LocalStorageAdapter.setItem('vidio_search_history', JSON.stringify(newQueries));

    $(e.currentTarget).parent().remove();
  }

  historyKeywords(query, syncRecommendation) {
    let matches = [];
    const searchHistory = LocalStorageAdapter.getItem('vidio_search_history');

    if (query.length < 2 && searchHistory) {
      const keywords = JSON.parse(searchHistory);
      matches = this.getKeywords(keywords, "RecentKeyword");
      return syncRecommendation(matches);
    }
  }

  getHistoryKeywords() {
    return JSON.parse(LocalStorageAdapter.getItem('vidio_search_history')) || [];
  }

  popularKeywords(query, syncRecommendation) {
    let matches = [];

    if (query.length < 2 && this.popularSearchKeywords) {
      matches = this.getKeywords(this.popularSearchKeywords, "PopularKeyword");
      return syncRecommendation(matches);
    }
  }

  cachedKeywords(query, syncRecommendation) {
    let matches = [];

    if(query.length > 2 && this.suggestionCache[query]) {
      matches = this.filterSuggestion(query);
      return syncRecommendation(matches);
    }
  }

  suggestedKeywords(query, syncRecommendation, asyncRecommendation) {
    let matches = [];

    if(query.length > 2 && !this.suggestionCache[query]) {
      $.getJSON(
        "/search/keyword-suggestions.json",
        { q: query }
      ).done((data) => {
        const badwords = (data.bad_words === undefined ? btoa('[]') : data.bad_words);
        let cache = this.filterBadwords(data.keywords, JSON.parse(atob(badwords)));
        this.suggestionCache[query] = [ ...new Set(cache) ];
        matches = this.filterSuggestion(query);
        return asyncRecommendation(matches);
      });
    }
  }

  getKeywords(keywords, source) {
    return keywords.map((keyword, index) => ({
      position: index + 1,
      value: keyword,
      source: source
    }));
  }

  onImpression(){
    this.ui.searchBox.on("typeahead:render", function(e, dataset) {
      if (dataset && dataset.source && !this.isImpressionSent[dataset.source]) {
        this.isImpressionSent[dataset.source] = true;
        this.ui.eventTarget.trigger($.Event(this.eventAction, {source: dataset.source}));
      }
    }.bind(this));

    this.ui.searchBox.on("typeahead:select", function() {
      Cookies.set("search_uuid", this.uuid());
    }.bind(this));
  }

  filterBadwords(keywords, badwords) {
    if (badwords.length === 0) return keywords;

    var cleanwords = [];
    var regex = new RegExp('(' + badwords.join('|') + ')', 'i');

    keywords.forEach(function(keyword) {
      if (!regex.test(keyword)) {
        cleanwords.push(keyword);
      }
    });

    return cleanwords;
  }

  filterSuggestion(query) {
    let matches = [];
    const sanitisedQuery = query.replace(/[#-.]|[[-^]|[?|{}]/g, '\\$&');
    let substrRegex = new RegExp(sanitisedQuery, 'i');
    let suggestionPosition = 1;
    const source = 'AutoSuggest';

    this.suggestionCache[query].forEach(function(keyword) {
      let image_url = '';
      let url_path = '';

      if (typeof(keyword) === "object") {
        url_path = keyword.url_path
        image_url = keyword.image_url
        keyword = keyword.text
      }

      if (substrRegex.test(keyword)) {
        let val = this.DOMParser.parseFromString(keyword, 'text/html').body;
        matches.push({ position: suggestionPosition, value: val.innerText, source, image: image_url, path: url_path });
        suggestionPosition++;
      }
    }.bind(this));

    return matches;
  }

  getTemplate({ value, source, position, image, path }) {
    const val = this.htmlEntities(value);

    let params = {
      q: val,
      qt: source
    };

    if (this.experimentEnabled()) {
      params.v = this.variant();
    }

    const queryParams = $.param(params);

    let href = "/search?utf8=✓&"+queryParams;
    let img = '&nbsp';
    let data_ahoy = '';

    const ahoyProps = {
      action: 'click',
      keyword: value,
      keyword_type: 'dynamic_suggestion',
      url: path
    }

    if (image !== null && image !== '' && source === 'AutoSuggest') {
      img = `<img class="search-suggestion__image" src="${image}" />`;
      data_ahoy = `data-ahoy-props='${JSON.stringify(ahoyProps)}'`;
      href = path
    }

    if(data_ahoy === ''){
      return `<div><a class="js-search-submit" data-source="${source}" data-suggestion-position="${position}" href="${href}">${img}<span>${val}</span></a></div>`;
    } else {
      return `<div><a class="js-search-submit" ${data_ahoy} data-source="${source}" data-suggestion-position="${position}" href="${href}">${img}<span>${val}</span></a></div>`;
    }
  }

  getRecentSearchTemplate({ value, source, position }) {
    const val = this.htmlEntities(value);

    let params = {
      q: val,
      qt: source,
      ua: '1'
    };

    if (this.experimentEnabled()) {
      params.v = this.variant();
    }

    const queryParams = $.param(params);

    return `<div><a class="js-search-submit" data-source="${source}" data-suggestion-position="${position}" href="/search?utf8=✓&${queryParams}">${val}</a><a class="site-header__tt-remove-search js-remove-search" data-keyword="${val}"></a></div>`;
  }

  getHeader(title) {
    return `<h2 class='site-header__tt-header-title'>${title}</h2>`;
  }

  getFooter() {
    return "<div class='site-header__tt-footer'/>";
  }
}
